import posthog from "posthog-js";
import { supabase } from "@/integrations/supabase/client";

const KEY = import.meta.env.VITE_POSTHOG_KEY || "phc_s5cRAcidB9VAYbGBySxr6FtEeXxqAPe2EGu5suVuvZMy";
const HOST = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

export function initPostHog() {
  if (typeof window === "undefined") return;
  if (initialized) return;
  initialized = true;

  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    person_profiles: "identified_only",
  });

  try {
    supabase.auth.getSession().then(({ data }) => {
      const user = data.session?.user;
      if (user) posthog.identify(user.id, { email: user.email ?? undefined });
    });
    supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT") {
        posthog.reset();
        return;
      }
      const user = session?.user;
      if (user) posthog.identify(user.id, { email: user.email ?? undefined });
    });
  } catch {
    // non-fatal
  }
}

export { posthog };
